export const dynamicForm = {
    namespaced: true,
    state: {
        errors: {},
        formSubmitted: false,
    },
    mutations: {
        SET_ERRORS(state, { fieldName, error }) {
            state.errors = { ...state.errors, [fieldName]: error };
        },
        SET_FORM_SUBMITTED(state, value) {
            state.formSubmitted = value;
        },
        RESET_STATE(state) {
            state.errors = {};
            state.formSubmitted = false;
        },
    },
    actions: {
        setErrors({ commit }, { fieldName, error }) {
            commit('SET_ERRORS', { fieldName, error });
        },
        setFormSubmitted({ commit }, value) {
            commit('SET_FORM_SUBMITTED', value);
        },
        resetState({ commit }) {
            commit('RESET_STATE');
        },
    },
    getters: {
        isFormValid(state) {
            return Object.values(state.errors).every((error) => !error);
        },
    },
};
